class AppEvents {
  constructor() {
    this.observers = [];
  }

  subscribe(func) {
    this.observers.push(func);
  }

  unsubscribe(func) {
    this.observers = this.observers.filter((observer) => observer !== func);
  }

  notify(evtName, data) {
    this.observers.forEach((observer) => observer(evtName, data));
  }
}

export default AppEvents;  